export default "__VITE_ASSET__DwuiKWt$__"